<template>
  <b-modal
    hide-footer
    id="modal-province-manage"
    ref="modal-province-manage"
    size="md"
    title="จัดการสิทธิ์จังหวัด"
  >
    <div class="container">
      <b-card>
        <b-row>
          <b-col cols="12" class="mb-2">
            <h3></h3>
          </b-col>
          <b-col cols="12" v-if="level !== 3">
            <b-form-group label="เขต">
              <vue-select
                transition=""
                label="text"
                v-model="areaSelect"
                :options="areaOptions"
                :clearable="false"
                :disabled="level > 1"
                class="mt-1 pl-1"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="level > 1">
            <b-form-group label="จังหวัด">
              <vue-select
                transition=""
                label="text"
                v-model="provinceSelect"
                :options="provinceOptions"
                :clearable="false"
                @input="provinceOnInput()"
                class="mt-1 pl-1"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="level > 2">
            <b-form-group label="เขต/อำเภอ">
              <vue-select
                transition=""
                label="text"
                v-model="districtSelect"
                :options="districtOptions"
                :clearable="false"
                @input="districtOnInput()"
                class="mt-1 pl-1"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <footer
          id="modal-transfer___BV_modal_footer_"
          class="modal-footer d-flex justify-content-between"
        >
          <button
            type="button"
            class="btn btn-secondary"
            block
            @click="onCancel"
          >
            ยกเลิก
          </button>
          <button type="button" class="btn btn-primary" block @click="onSubmit">
            บันทึก
          </button>
        </footer>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
} from "bootstrap-vue";

import * as storeMaster from "@/store/api/master/index.js";

import VueSelect from "vue-select";

import CommonTable from "./commonTableModal";

import appsettings from "@/store/app-settings";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    VueSelect,
    CommonTable,
    BCard,
  },
  props: {},
  data() {
    return {
      level: 1,
      userDepartmentRoleID: null,
      roleId: null,
      userId: null,
      areaCode: null,
      areaName: null,
      provinceCode: null,
      provinceName: null,
      districtCode: null,
      subDistrictCode: null,
      areaSelect: null,
      provinceSelect: null,
      districtSelect: null,
      subDistrictSelect: null,
      areaOptions: [],
      provinceOptions: [],
      districtOptions: [],
      subDistrictOptions: [],
    };
  },
  created() {},
  mounted() {
    //console.log("modal mounted");
  },
  methods: {
    onShow(user, level) {
      /// ณ ปัจจุบันจะมมีแค่ level 1 = เขต, level 2 = จังหวัด
      const _this = this;

      // console.log(
      //   "onShow",
      //   user.userDepartmentRoleId,
      //   user.area,
      //   user.areaName,
      //   user.province,
      //   user.provinceName,
      //   user.district,
      //   user.subDistrict
      // );
      console.log("onShow", user, level);

      this.level = level;
      this.userDepartmentRoleId = user.userDepartmentRoleId;
      this.roleId = user.roleId;
      this.areaCode = user.area;
      this.areaName = user.areaName;
      this.provinceCode = user.provinceCode;
      this.provinceName = user.provinceName;
      this.districtCode = user.districtCode;
      this.subDistrictCode = user.subDistrictCode;

      this.initArea();

      if (this.level > 1) {
        this.initProvince();
      }

      // if (this.level > 2) {
      //   this.initDistrict();
      // }
    },
    initArea() {
      const _this = this;
      storeMaster
        .getArea()
        .then(function(response) {
          _this.areaOptions = response.data.data;
          // set userList default options
          _this.areaSelect = _this.areaOptions.find((value) => {
            return value.value === _this.areaCode;
          });

          // ถ้ายังหาไม่เจอให้มาหาจากชื่ออีกที
          if (!_this.areaSelect) {
            _this.areaSelect = _this.areaOptions.find((value) => {
              return value.text === _this.areaName;
            });
          }
          console.log(
            "_this.areaSelect",
            _this.areaSelect,
            _this.areaCode,
            _this.areaOptions
          );
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    initProvince() {
      const _this = this;
      storeMaster
        .getProvince(_this.areaCode)
        // .getProvince()
        .then(function(response) {
          _this.provinceOptions = response.data.data;
          // set userList default options
          _this.provinceSelect = _this.provinceOptions.find((value) => {
            return value.value === _this.provinceCode;
          });

          // ถ้ายังหาไม่เจอให้ค้นจากชื่ออีกที
          if (!_this.provinceSelect) {
            _this.provinceSelect = _this.provinceOptions.find((value) => {
              return value.text === _this.provinceName;
            });
          }

          console.log("provinceSelect", _this.provinceSelect);

          if (
            (_this.provinceCode !== null ||
              _this.provinceSelect?.value != null) &&
            _this.level > 2
          ) {
            _this.initDistrict();
          }
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    initDistrict() {
      const _this = this;
      storeMaster
        .getDistrict(_this.provinceCode || _this.provinceSelect?.value)
        .then(function(response) {
          _this.districtOptions = [
            { value: null, text: "ส่วนกลาง" },
            ...response.data.data,
          ];
          // set userList default options
          _this.districtSelect = _this.districtOptions.find((value) => {
            return value.value === _this.districtCode;
          });

          if (
            (_this.districtCode !== null ||
              _this.districtSelect?.value != null) &&
            _this.level > 3
          ) {
            _this.initSubDistrict();
          }
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    initSubDistrict() {
      const _this = this;

      storeMaster
        .getSubDistrict(_this.districtCode)
        .then(function(response) {
          _this.subDistrictOptions = response.data.data;
          // set userList default options
          _this.subDistrictSelect = _this.subDistrictOptions.find((value) => {
            return value.value === _this.subDistrictCode;
          });
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    updateProvince() {
      storeMaster
        .getProvince()
        .then(function(response) {
          // handle success
          console.log("response", response);
          var localProvince = response.data.data;
          _this.provinces = response.data.data;

          // set userList default options
          users = users.map((value) => {
            var option = localProvince.find((prov) => {
              return prov.value === value.provinceCode;
            });

            value.province = option;

            //value.province = localProvince[0]
            return value;
          });

          //_this.$forceUpdate();

          //console.log('_this.rows', _this.rows)
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    onSubmit() {
      const data = {
        userDepartmentRoleId: this.userDepartmentRoleId,
        roleId: this.roleId,
        userId: this.userId,
        area: this.areaSelect !== null ? this.areaSelect.value : null,

        // province: this.provinceSelect !== null ? this.provinceSelect?.value : null,
        province:
          this.provinceSelect !== null
            ? this.roleId.toLowerCase() ===
              appsettings.complaintRoleId.area.toLowerCase()
              ? null
              : this.provinceSelect?.value
            : null,

        district:
          this.districtSelect !== null ? this.districtSelect?.value : null,
        subDistrict:
          this.subDistrictSelect !== null
            ? this.subDistrictSelect?.value
            : null,
      };
      console.log("onSubmit", data);
      this.$emit("handle-submit", data);
    },
    onCancel() {
      this.$refs["modal-province-manage"].hide();
    },
    areaOnInput() {
      console.log("areaOnInput", this.areaSelect);
      /// ตอนนี้ไม่ต้องทำอะไร
    },
    provinceOnInput() {
      console.log("provinceOnInput", this.provinceSelect);

      /// หาค่าจาก areaOptions แล้ว set ค่า
      const _this = this;
      storeMaster
        .getAreaByProvince(_this.provinceSelect.value)
        .then((response) => {
          console.log(
            "got area",
            response.data.success,
            response.data.data,
            response.data.data.value
          );
          if (response.data.success) {
            if (response.data.data && response.data.data.value) {
              const areaFilter = _this.areaOptions.find((value) => {
                return value.value == response.data.data.value;
              });

              console.log("areaFilter", areaFilter);

              if (areaFilter) {
                _this.areaSelect = areaFilter;
              }
            }
          }
        })
        .catch((error) => {
          console.log("ex", error);
        });

      if (_this.provinceSelect?.value != null && _this.level > 2) {
        _this.initDistrict();
      }
    },
    districtOnInput() {
      console.log("districtOnInput", this.districtSelect);

      /// หาค่าจาก areaOptions แล้ว set ค่า
      const _this = this;

      if (_this.districtSelect?.value != null && _this.level > 3) {
        _this.initSubDistrict();
      }
    },
  },
};
</script>

<style></style>
